export const globalStyles = require('./styles.module.css')
